export const VERSION_CONFLICT_MESSAGE =
    "این مورد توسط مدیر دیگری تغییر کرده است. لطفاً صفحه را بازخوانی کنید و دوباره تلاش کنید.";

export const isVersionConflict = (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    return status === 409 && data?.errorCode === "VersionConflict";
};

export const getVersionConflictMessage = (error) => {
    const data = error?.response?.data;
    if (typeof data?.message === "string" && data.message.trim()) {
        return data.message;
    }
    return VERSION_CONFLICT_MESSAGE;
};

/** Read Version from an entity or ApiResponseDto wrapper. */
export const extractVersion = (payload) => {
    if (payload == null || typeof payload !== "object") return undefined;
    if (payload.version != null) return payload.version;
    if (payload.Version != null) return payload.Version;
    if (payload.data != null && typeof payload.data === "object") {
        return extractVersion(payload.data);
    }
    return undefined;
};
